import React, { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../../services/api';

const ResetRoute = ({ children }) => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('validating'); // validating | valid | expired | invalid

  const username = searchParams.get('u');
  const apiName = searchParams.get('a');
  const token = searchParams.get('t');

  useEffect(() => {
    if (!username || !apiName || !token) {
      setStatus('invalid');
      return;
    }

    authAPI.validateResetToken(apiName, username, token)
      .then((response) => {
        setStatus(response.data ? 'valid' : 'expired');
      })
      .catch(() => {
        setStatus('expired');
      });
  }, [username, apiName, token]);

  if (status === 'validating') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <p>Validating reset link...</p>
      </div>
    );
  }

  if (status === 'invalid') {
    return <Navigate to="/login" replace />;
  }

  if (status === 'expired') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <h2>Password Reset Expired</h2>
          <p>This link has expired. Please request a new password reset.</p>
          <a href="/portal/login">Return to Login</a>
        </div>
      </div>
    );
  }

  return children;
};

export default ResetRoute;
